export default "__VITE_PUBLIC_ASSET__3211479e__"